import { HttpMethod, Command } from "~/extensions/api";
// import { myPageStore } from "~/store/MyPageStore";
export class FindSeikyuInfo extends Command {
    constructor(orgNyukyokeiyakuNo) {
        super(HttpMethod.Get, `seikyuInfo/search/${orgNyukyokeiyakuNo}`);
    }
}
